import { AgentInfo, NetworkInfo, WidgetSection } from './components';
import {
    Box,
    Button,
    Card,
    Container,
    Flex,
    Grid,
    Loader,
    MultiSelect,
    Portal,
    Select,
    Stack,
    Text,
    Title,
} from '@mantine/core';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import { pascalToFriendly } from '../../../../utils/text';
import { useAuthStore } from '../../../../store';
import useGetAgentByIdQuery from '../../../../http/queries/resources/useGetAgentById';
import { useParams } from 'react-router-dom';

const AgentFullView = ({ ...props }) => {
    const { id: agentId } = useParams();
    const userProfile = useAuthStore((state) => state.userProfile);
    const { isLoading, data: agent } = useGetAgentByIdQuery(agentId);

    return (
        <Container fluid>
            {isLoading ? (
                <Loader />
            ) : (
                <Grid>
                    <Grid.Col span={'content'}>
                        <AgentInfo agent={agent} />
                    </Grid.Col>

                    <Grid.Col span={'content'}>
                        <NetworkInfo
                            agent={agent}
                            networkState={agent?.networkState || {}}
                        />
                    </Grid.Col>
                </Grid>
            )}
        </Container>
    );
};

export default AgentFullView;
